import { render, staticRenderFns } from "./GoodsPrimaryKey.vue?vue&type=template&id=114b0869&scoped=true&"
import script from "./GoodsPrimaryKey.vue?vue&type=script&lang=js&"
export * from "./GoodsPrimaryKey.vue?vue&type=script&lang=js&"
import style0 from "./GoodsPrimaryKey.vue?vue&type=style&index=0&id=114b0869&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114b0869",
  null
  
)

export default component.exports